import React from 'react'
import styled from 'styled-components'
import SectionTitle from './SectionTitle'
import { Row, Col } from 'react-flexbox-grid';
import {Spacer} from 'layout/util'

const ImageBlock = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Img = styled.img`
	border: 3px solid black;
	border-radius: 3px;
	object-fit: cover;
	object-position: 50% 0;
	height: 200px;
	width: 200px;
`;

const Caption = styled.h3`
	text-align: center;
`;

const CarouselContainer = styled.div`
	display: flex;
	justify-content: space-evenly;
	@media screen and (max-width: 767px) {
		flex-direction: column;		
	}
`;

const PhotoCarousel = (props) => {
	const {title, subtitle, images, socialMedia} = props.data;

	const smLinks = socialMedia.map( (smAccount, i) => {
		if (i === socialMedia.length-1) {
			return(
				<React.Fragment key={i}>
					and&nbsp;
					<a href={smAccount.link}>{smAccount.label}</a>
					.
				</React.Fragment>
			);
		} else {
			return(
				<React.Fragment key={i}>
					<a href={smAccount.link}>{smAccount.label}</a>
					,&nbsp;
				</React.Fragment>
			);
		}
	});
	const subtitleWithLinks = 
		<React.Fragment>
			{subtitle}&nbsp;{smLinks} 
		</React.Fragment>;

	const imageBlocks = images.map ( (image, i) => (	
		<ImageBlock key={i}>
			<a href={image.link}>
				<Img src={image.src} />
			</a>
			<Caption>{image.caption}</Caption>
		</ImageBlock>
		));

	return(
		<Row>
	    <Col 
	    	xsOffset={0} xs={12} 
	      smOffset={0} sm={12} 
	      mdOffset={1} md={10} 
	      lgOffset={1} lg={10}
	    >
			<SectionTitle title={title} subtitle={subtitleWithLinks} />
	    <Spacer height={20}/>
			<CarouselContainer>
				{imageBlocks}
			</CarouselContainer>
			</Col>
		</Row>
	);
}

export default PhotoCarousel;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/PhotoCarousel.js